import { useAppSelector } from "../../../../../redux/hooks"
import { KTIcon } from "../../../../../_metronic/helpers"
import { useEffect, useState, useCallback } from 'react'
import { getStatusSesiones, getStatusSesionesglobales } from "../requests/request"
import Spinnerabsolute from "../../Spinner/Spinnerabsolute"
import { utils, writeFile } from 'xlsx';
import { useAuth } from "../../../auth"

export default function Statussesiones(props: any) {
  const Id = useAppSelector(state => state.SuscriptionSlice.id)
  const Type = useAppSelector(state => state.CloudSlice.Type)
  const tenant = useAppSelector(state => state.TenantSlice.id)
  const nameregion = useAppSelector(state => state.RegionSlice.name)
  const FlagReg = useAppSelector(state => state.FlagSlice.value)
  const { currentUser } = useAuth()

  const [Loading, setLoading] = useState(false)
  const [StatuSessions, setStatuSessions] = useState([{
    neighbor: '',
    as: '',
    life: '',
    desc: '',
    instance: '',
    suscription: '',
    status: '',
  }])

  useEffect(() => {
    setLoading(true)
    let shouldUpdateState = true;

    //if (FlagReg === true) {
      const fetchData = async () => {
        try {
          let response;
          if (currentUser?.ListPermiso?.includes('Home.Status')  && Type !== 'CloudGlobal' && props.id === 1 && tenant === 0) {
            response = await getStatusSesiones(Id, Type, nameregion)
          } else if (currentUser?.ListPermiso?.includes('Home.Status')  && Type !== 'CloudGlobal' && props.id === 1 && tenant !== 0) {
            response = await getStatusSesionesglobales(Id, tenant, Type, nameregion)
          } else if (currentUser?.ListPermiso?.includes('Home.Status') && Type === 'CloudGlobal' && props.id === 1 && tenant === 0) {
            response = await getStatusSesiones(Id)
          } else if (currentUser?.ListPermiso?.includes('Home.Status') && Type === 'CloudGlobal' && props.id === 1 && tenant !== 0) {
            response = await getStatusSesionesglobales(Id, tenant)
          }

          if (shouldUpdateState) {
            setStatuSessions(response?.data || [])
          }
        } catch (error) {
          console.error('Error fetching data:', error)
        } finally {
          if (shouldUpdateState) {
            setLoading(false) // Siempre desactiva el loading
          }
        }
      }
      fetchData()
    /*} else {
      setLoading(false) // Asegura desactivar el loading si no se cumplen las condiciones
    }*/

    return () => {
      shouldUpdateState = false;
    };
  }, [props.id, FlagReg, nameregion])

  useEffect(() => {
    setLoading(true)
    let shouldUpdateState = true;

    if (Id && (Type !== '' || Type !== null)) {
      const fetchData = async () => {
        try {
          let response
          if (currentUser?.ListPermiso?.includes('Home.Status') && props.id === 1 && tenant === 0) {
            response = await getStatusSesiones(Id)
          } else if (currentUser?.ListPermiso?.includes('Home.Status')  && props.id === 1 && tenant !== 0) {
            response = await getStatusSesionesglobales(Id, tenant)
          }

          if (shouldUpdateState) {
            setStatuSessions(response?.data || [])
          }
        } catch (error) {
          console.error('Error fetching data:', error)
        } finally {
          if (shouldUpdateState) {
            setLoading(false) // Siempre desactiva el loading
          }
        }
      }
      fetchData()
    } else {
      setLoading(false) // Asegura desactivar loading si no se cumplen las condiciones
    }

    return () => {
      shouldUpdateState = false;
    };
  }, [Id, Type])

  useEffect(() => {
    if (Type) {
      setStatuSessions([])
    }
  }, [Type])

  const exportFile = useCallback(() => {
    if (Id !== 0 && Type !== 'Global') {
      const ws = utils.json_to_sheet(StatuSessions);
      const wb = utils.book_new();
      utils.book_append_sheet(wb, ws, "BGP");
      utils.sheet_add_aoa(ws, [['Instance', 'BGP Neighbor', 'As', 'Status']], { origin: "A1" });
      writeFile(wb, "BGP Status.xlsx");
    } else if (Id === 0 && Type === 'Global') {
      const ws = utils.json_to_sheet(StatuSessions);
      const wb = utils.book_new();
      utils.book_append_sheet(wb, ws, "BGP");
      utils.sheet_add_aoa(ws, [['Subscription', 'Instance', 'BGP Neighbor', 'As', 'Status']], { origin: "A1" });
      writeFile(wb, "BGP Status.xlsx");
    }
  }, [StatuSessions, Id, Type]);

  return (
    <>
      <div className="card card-custom border border-gray-300">
        {currentUser?.ListPermiso?.includes('Home.Status') && Id !== 0 && Loading && <Spinnerabsolute />}
        {currentUser?.ListPermiso?.includes('Home.Status') && Type === 'CloudGlobal' && Loading && <Spinnerabsolute />}
        <div>
          <br />
          <div className='d-flex align-items-center justify-content-between'>
            <p className="text-marino f-titulo fs-md text-center" style={{ flex: '0 0 80%' }}>BGP SESSIONS STATUS</p>
            {currentUser?.ListPermiso?.includes('Home.Status') && (
              <button className="btn-light-marino f-parrafo ms-3" style={{ flex: '0 0 10%', marginRight: '10px', marginBottom: '5px' }} onClick={exportFile}>
                <i className="bi bi-download"></i>
              </button>
            )}
          </div>
        </div>
        <div className="border shadow-sm rounded-lg menu-scroll">
          <div className="relative w-full overflow-auto">
            <div className="card-body card-scroll table-container h-250px">
              {StatuSessions.length === 0 ? (
                <div className="no-data-message">No Data Available</div>
              ) : (
                <table className="w-full f-parrafo caption-bottom custom-table">
                  <thead className='table-header-light bg-marino table-header-fixed'>
                    <tr>
                      <th className="table-cell">Instance</th>
                      <th className="table-cell">Neighbor</th>
                      <th className="table-cell">AS-Neighbor</th>
                      <th className="table-cell">Lifetime</th>
                      <th className="table-cell">Description</th>
                      {Type === 'CloudGlobal' && <th className="table-cell">Subscription</th>}
                      <th className="table-cell">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {StatuSessions.map((d, i) => (
                      <tr key={i} className="table-row">
                        {d.instance.includes(Type) && Id !== 0 && <td className="table-cell">{d.instance}</td>}
                        {Type === 'CloudGlobal' && <td className="table-cell">{d.instance}</td>}
                        {d.instance.includes(Type) && Id !== 0 && <td className="table-cell">{d.neighbor}</td>}
                        {Type === 'CloudGlobal' && <td className="table-cell">{d.neighbor}</td>}
                        {d.instance.includes(Type) && Id !== 0 && <td className="table-cell">{d.as}</td>}
                        {Type === 'CloudGlobal' && <td className="table-cell">{d.as}</td>}
                        {d.instance.includes(Type) && Id !== 0 && <td className="table-cell">{d.life}</td>}
                        {Type === 'CloudGlobal' && <td className="table-cell">{d.life}</td>}
                        {d.instance.includes(Type) && Id !== 0 && <td className="table-cell">{d.desc}</td>}
                        {Type === 'CloudGlobal' && <td className="table-cell">{d.desc}</td>}
                        {Type === 'CloudGlobal' && <td className="table-cell">{d.suscription}</td>}
                        {d.instance.includes(Type) && Id !== 0 && d.status === 'UP' && <td className="table-cell"><KTIcon iconName='bi bi-check-circle' className='text-success fs-1' /></td>}
                        {d.instance.includes(Type) && Id !== 0 && d.status === 'Connect' && <td className="table-cell"><KTIcon iconName='bi bi-exclamation-triangle' className='text-warning fs-1' /></td>}
                        {d.instance.includes(Type) && Id !== 0 && d.status === 'Active' && <td className="table-cell"><KTIcon iconName='bi bi-exclamation-triangle' className='text-warning fs-1' /></td>}
                        {d.instance.includes(Type) && Id !== 0 && d.status === 'Idle' && <td className="table-cell"><KTIcon iconName='bi bi-exclamation-triangle' className='text-warning fs-1' /></td>}
                        {Type === 'CloudGlobal' && d.status === 'UP' && <td className="table-cell"><KTIcon iconName='bi bi-check-circle' className='text-success fs-1' /></td>}
                        {Type === 'CloudGlobal' && d.status === 'Connect' && <td className="table-cell"><KTIcon iconName='bi bi-exclamation-triangle' className='text-warning fs-1' /></td>}
                        {Type === 'CloudGlobal' && d.status === 'Active' && <td className="table-cell"><KTIcon iconName='bi bi-exclamation-triangle' className='text-warning fs-1' /></td>}
                        {Type === 'CloudGlobal' && d.status === 'Idle' && <td className="table-cell"><KTIcon iconName='bi bi-exclamation-triangle' className='text-warning fs-1' /></td>}
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
              {Id === 0 && Type !== 'Global' && (
                <table className="table table-striped gy-7 gs-7">
                  <tbody>
                    <tr>
                      <td className="text-center">Select a Cloud with available subscriptions</td>
                    </tr>
                  </tbody>
                </table>
              )}
            </div>
            <div className="card-footer"></div>
          </div>
        </div>
      </div>
    </>
  )
}
